module.exports = __webpack_public_path__ + "9d12d946c5a382dca3833e0ce197aaf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/legallais.png
// module id = 119
// module chunks = 0